import { useEffect } from 'react';
import { changeLocale, useIntl } from 'gatsby-plugin-react-intl';

import type { languages } from '@workspace/localization';

export const useForceLanguage = (forcedLocale: (typeof languages)[keyof typeof languages]) => {
    const { locale: currentLocale } = useIntl();

    useEffect(() => {
        if (currentLocale !== forcedLocale) {
            changeLocale(forcedLocale);
        }
    }, [currentLocale, forcedLocale]);
};
